<template>
  <catalog-repetitor-page />
</template>

<script>
import CatalogRepetitorPage from '../../index.vue';

export default {
  name: 'RepectitorSecondFilter',
  components: { CatalogRepetitorPage },
  layout: 'DefaultLayoutV2',
  scrollToTop: false,
};
</script>
